/* ============================================================
   AVISO DE BRINDE NO CARRINHO
   ------------------------------------------------------------
   Atualiza a mensagem da promoção e o indicador de frete.
   As metas de frete são lidas diretamente das configurações do tema.

   Regras:
     KIT15, KIT16 ou KIT17: 1 frigideira por pedido
     O brinde não é cumulativo.
   ============================================================ */
(function () {
  if (window.__zayaGiftMsgInit) return;
  window.__zayaGiftMsgInit = true;

  var ELIGIBLE_KITS = ['KIT15', 'KIT16', 'KIT17'];
  var SLOT = '#right-drawer-slot';

  var _fetch = window.fetch.bind(window);
  var timer = null;

  function getCart() {
    return _fetch('/cart.js?_=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  function qty(cart, sku) {
    return cart.items
      .filter(function (item) {
        return item.sku === sku;
      })
      .reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
  }

  function gifts(cart) {
    return ELIGIBLE_KITS.some(function (sku) {
      return qty(cart, sku) > 0;
    }) ? 1 : 0;
  }

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function renderShipping(cart) {
    var shipping = document.getElementById('zaya-free-shipping');
    var brMessage = document.getElementById(
      'zaya-free-shipping-br-message'
    );
    var spMessage = document.getElementById(
      'zaya-free-shipping-sp-message'
    );
    var brProgress = document.getElementById(
      'zaya-free-shipping-br-progress'
    );
    var spProgress = document.getElementById(
      'zaya-free-shipping-sp-progress'
    );

    if (
      !shipping ||
      !brMessage ||
      !spMessage ||
      !brProgress ||
      !spProgress
    ) {
      return;
    }

    var brGoal = Number(shipping.dataset.goalBr);
    var spGoal = Number(shipping.dataset.goalSp);
    var total = cart.total_price;

    if (!cart.item_count) {
      brMessage.innerHTML = '';
      spMessage.innerHTML = '';
      brProgress.value = 0;
      spProgress.value = 0;
      return;
    }

    brProgress.value = Math.min(total, brGoal);
    spProgress.value = Math.min(total, spGoal);

    brMessage.innerHTML = total >= brGoal
      ? 'Você ganhou <span class="faltaapenas">FRETE GRÁTIS</span>!'
      : 'Brasil: Falta apenas <span class="faltaapenas">' +
        money(brGoal - total) +
        '</span> para ganhar FRETE GRÁTIS!';

    spMessage.innerHTML = total >= spGoal
      ? 'Você ganhou <span class="faltaapenas">FRETE GRÁTIS para São Paulo</span>!'
      : 'São Paulo: Falta apenas <span class="faltaapenas">' +
        money(spGoal - total) +
        '</span> para ganhar FRETE GRÁTIS!';
  }

  function ensureBox() {
    var box = document.getElementById('zaya-promo-message');

    if (box) return box;

    var container = document.querySelector(SLOT + ' > div');

    if (!container) return null;

    box = document.createElement('div');
    box.id = 'zaya-promo-message';
    box.setAttribute('aria-live', 'polite');

    var anchor = null;
    var children = container.children;

    for (var i = 0; i < children.length; i++) {
      if (
        children[i].classList &&
        children[i].classList.contains('flex-auto')
      ) {
        anchor = children[i];
        break;
      }
    }

    if (anchor) {
      container.insertBefore(box, anchor);
    } else {
      container.appendChild(box);
    }

    return box;
  }

  function renderMessage(cart) {
    var box = ensureBox();

    if (!box) return;

    if (!cart.item_count) {
      box.style.display = 'none';
      box.innerHTML = '';
      return;
    }

    var message = gifts(cart) === 1
      ? 'Você ganhou 1 frigideira nesta compra.'
      : 'Inclua na sua compra 1 Kit Protein Bread e ganhe 1 frigideira.';

    box.style.display = 'block';
    box.innerHTML =
      '<div style="margin:10px 45px 0;padding:12px 14px;background:#FEEEDF;color:#6D1733;border-radius:8px;font-size:13px;font-weight:600;line-height:1.35;text-align:center">' +
      message +
      '</div>';
  }

  function apply(cart) {
    renderMessage(cart);
    renderShipping(cart);
  }

  function scheduleWithCart(cart) {
    clearTimeout(timer);

    timer = setTimeout(function () {
      apply(cart);
    }, 150);
  }

  function scheduleFetch() {
    clearTimeout(timer);

    timer = setTimeout(function () {
      getCart().then(apply);
    }, 250);
  }

  window.fetch = function () {
    var url = String(
      (arguments[0] && arguments[0].url) || arguments[0] || ''
    );

    var match = url.match(/\/cart\/(add|change|update|clear)(\.js)?/);
    var request = _fetch.apply(null, arguments);

    if (match) {
      if (match[1] === 'add') {
        request.then(function () {
          scheduleFetch();
        });
      } else {
        request.then(function (response) {
          response
            .clone()
            .json()
            .then(function (cart) {
              scheduleWithCart(cart);
            })
            .catch(scheduleFetch);
        });
      }
    }

    return request;
  };

  window.addEventListener(
    'shapes:modalcart:afteradditem',
    scheduleFetch
  );

  if (document.body) {
    document.body.addEventListener(
      'shapes:modalcart:afteradditem',
      scheduleFetch
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFetch);
  } else {
    scheduleFetch();
  }
})();

document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});